import React, { useEffect, useState } from "react";
import { RadioButton } from "@progress/kendo-react-inputs";

/**
 * Option buttons renderer component (radio buttons for single selection)
 * @param {Object} props - Component props
 * @param {Object} props.element - Element object
 * @param {string} props.selectedValue - Currently selected value
 * @param {Function} props.onOptionClick - Handler for option selection
 * @returns {JSX.Element} Option buttons component
 * @author Abhishek Dhillon
 */
const OptionButtons = ({ element, filteredOptions, showResponses, onOptionClick }) => {
  const { properties = {}, value = null } = element;
  const { required = false } = properties;
  const getSelectedValue = (val) => {
    if (typeof val === "object") {
      return val?.value;
    }
    return filteredOptions.find((option) => option?.value === val)?.value;
  };
  const [selectedValue, setSelectedValue] = useState(getSelectedValue(value));

  useEffect(() => {
    if (value && onOptionClick) {
      onOptionClick(getSelectedValue(value));
    }
  }, []);

  return (
    <div className='d-flex'>
      <div className='option-buttons-container d-flex flex-column border w-100 p-2'>
        {filteredOptions.map((option, index) => {
          const isSelected = selectedValue === option.value;
          return (
            <div key={index} className={`option-item ${isSelected ? "selected" : ""}`}>
              <div className='option-radio-wrapper'>
                <RadioButton
                  checked={isSelected}
                  onChange={() => {
                    onOptionClick(option.value);
                    setSelectedValue(option.value);
                  }}
                  label={option.label}
                  disabled={showResponses}
                />
              </div>
            </div>
          );
        })}
      </div>
      {required && <span className='required-asterisk text-danger ms-1 ml-1'>*</span>}
    </div>
  );
};

export default OptionButtons;
